// --------------------------------------------------------------
// Created On: 2026-09-03
// Author: Dimitra Weinstein
//
// Last Modified: 2026-10-01
// Modified By: Zachary Thomas
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------
import React from "react";
import styles from "./EditAssetButton.module.scss";

// EditAssetButton component renders a button that triggers the Edit Asset modal.
export default function EditAssetButton(props: Props): Component {
  return (
    <button
      data-test="edit-asset-button"
      className={`${styles.body} btn btn-light ${props.className}`}
      type="button"
      onClick={() => props.handleEditAsset()}
    >
      <span
        className="d-none d-lg-inline-block d-xl-none d-xxl-inline-block pb-1 align-items-center"
        style={{ fontSize: "0.95rem" }}
      >
        Edit Asset
      </span>
      <span className="d-inline-block d-lg-none d-xl-inline-block d-xxl-none" style={{ fontSize: "0.95rem" }}>
        Edit
      </span>
    </button>
  );
}

interface Props {
  handleEditAsset: () => void;
  className?: string;
}
